import { render, staticRenderFns } from "./KarnatakaCustomers.vue?vue&type=template&id=623a83e8&scoped=true"
import script from "./KarnatakaCustomers.vue?vue&type=script&lang=js"
export * from "./KarnatakaCustomers.vue?vue&type=script&lang=js"
import style0 from "./KarnatakaCustomers.vue?vue&type=style&index=0&id=623a83e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623a83e8",
  null
  
)

export default component.exports